
import { getFileUploadURL } from '@/utils/constant'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import OSS from 'ali-oss'
import { getOssPlicy } from '@/api/user'

@Component({
  name: 'logoUploader'
})
export default class extends Vue {
  @Prop({ required: true }) private logo!: string
  private apiUrl: string = getFileUploadURL() + '/upload-file'
  private ossParams: any = {}
  private uploadDir: any = ''
  private dialogVisible: boolean = false
  private dialogImageUrl = ''

  get language() {
    return AppModule.language
  }

  private handleAvatarSuccess(res, file) {
    this.$emit('uploadOk', res.file_path)
  }

  private beforeAvatarUpload(file) {
    const isLt5M = file.size / 1024 / 1024 < 100
    if (!isLt5M) {
      this.$message.error('File size should not exceed 100MB!')
    }
    return isLt5M
  }

  // 预览图片
  private handlePictureCardPreview () {
    this.dialogImageUrl = this.videoLink
    this.dialogVisible = true
  }

  private videoLink:any = ''
  private upload (obj) {
    const random_name = this.randomFileName(obj.file, 6)
    const oss = new OSS(this.ossParams)
    oss
      .put(random_name, obj.file)
      .then(({ res }) => {
        this.videoLink = res.requestUrls[0]
        this.$emit('uploadOk', res.requestUrls[0])
      })
      .catch(e => {
        console.log(e, '失败了')
      })
  }

  // 随机生成文件名
  private randomFileName (file, len) {
    len = len || 32
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678'
    let maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    let fileName =
      this.uploadDir +
      pwd +
      '_' +
      new Date().getTime() +
      '.' +
      file.name.split('.').pop()
    return fileName
  }

  // oss配置
  private async getOssPlict () {
    try {
      getOssPlicy().then((res: any) => {
        const {
          expiration,
          access_key_secret,
          access_key,
          sts_token,
          upload_dir,
          bucket,
          region
        } = res
        this.ossParams = {
          secure: true,
          region: region,
          bucket: bucket,
          accessKeyId: access_key,
          accessKeySecret: access_key_secret,
          stsToken: sts_token
        }
        this.uploadDir = upload_dir
      })
    } catch (e) {}
  }

  mounted () {
    this.getOssPlict()
  }
}
